import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../appTheme";



export const PluginStyle = StyleSheet.create({
    flex:{
        flex:1,
        backgroundColor:appColors.lightBackgroundColor
    },
    tabOuterView:{
        flexDirection: 'row', 
        backgroundColor: appColors.light 
    },
    closeIcon:{ 
        backgroundColor: appColors.lightBackgroundColor, 
        borderTopRightRadius: 30, 
        borderTopLeftRadius: 30 
    },
    headerText:{ 
        alignItems: 'flex-start', 
        fontSize: fontSize.largerFontSize, 
        fontFamily: appFonts.bold, 
        color: appColors.lightDark 
},
    modalView:{ 
        flex: 1, 
        backgroundColor: appColors.transparentBackground, 
        alignItems: 'center', 
        justifyContent: 'center'
    },
    tabInnerView:{
        marginLeft: 20, 
        marginRight: 8, 
        paddingTop: 20, 
        paddingBottom: 15, 
        marginTop: 5, 
        borderTopRightRadius: 26, 
        borderTopLeftRadius: 26
    },
    searchView:{
        flexDirection:'row',
        marginVertical:7,
        marginTop:10
    },
    noRecordsView: {
        justifyContent: "center"
    },
    noRecords: {
        color: appColors.lightDark,
        textAlign: 'center'
    },
    descriptionTextStyle: {
        color: appColors.lightDark,
        flexWrap: "wrap",
        marginTop: 8,
        textAlign: "justify",
        paddingRight: 15
    },
    loader: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center'
    },
    headerStyle: {
        fontSize: fontSize.largerFontSize,
        color: appColors.lightDark,
        textAlign: 'left',
        fontFamily: appFonts.bold,
        marginLeft:17
    },
    viewContainer: {
        backgroundColor: appColors.lightBackgroundColor,
        justifyContent: 'space-between',
        flexDirection: 'row',
        height: 30,
    },
    cardContainer: {
        margin: 0,
        paddingBottom: 0
    },
    buttonView: {
        flexDirection: 'row', 
        justifyContent: 'flex-end', 
        paddingBottom: 20
    },
    cancelButtonStyle: {
        marginTop: 20, 
        borderRadius: 7, 
        borderColor: appColors.lightGrey, 
        borderWidth: 0.5
    },
    cancelTitleStyle: {
        color: appColors.lightDark, 
        fontSize: fontSize.mediumFontSize, 
        fontFamily: appFonts.bold, 
        marginHorizontal: 7
    },
    saveButtonStyle: {
        marginTop: 20, 
        borderRadius: 7, 
        marginHorizontal: 15, 
        right: 3
    },
    saveButtonTitleStyle: {
        color: appColors.light, 
        fontSize: fontSize.mediumFontSize, 
        fontFamily: appFonts.bold, 
        marginHorizontal: 7
    },
    labelStyle: {
        fontSize: fontSize.mediumFontSize, 
        fontFamily: appFonts.bold, 
        marginVertical:5,
        color:appColors.lightDark
    },
    inputStyle: {
        fontSize: fontSize.mediumFontSize, 
        color: appColors.lightDark, 
        fontFamily: appFonts.medium
    },
    inputContainerStyle: {
        borderColor: appColors.borderColor
    },
})